import BgTrainingCenter from '../assets/videos/bg_training_center.mp4'
import FirstHeroVideo from '../assets/videos/first_hero_video.mp4'
import secondHerovideos from '../assets/videos/second_hero_video.mp4'
import thirdHeroVideo from '../assets/videos/third_hero_video.mp4'

import Moments_1 from '../assets/videos/moments/moment_1.mp4'

const VideoPallet = {
 BgTrainingCenter,
 FirstHeroVideo,
 secondHerovideos,
 thirdHeroVideo,
 Moments_1,
}

export default VideoPallet